import { Injectable } from '@angular/core';

import { Timeplan } from './timeplan';
import { TIMEPLANS } from './timeplans';
import { MOCKTIMEPLANS } from './mock-timeplans';

@Injectable()
export class TimeplansService {

  getTimeplans(): Promise<Timeplan[]> {
    return Promise.resolve(TIMEPLANS);
  }

  getMockTimeplans(): Promise<Timeplan[]> {
    return Promise.resolve(MOCKTIMEPLANS);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/strategy-overview/timeplans/timeplans.service.ts